import { DownOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Divider, Dropdown, Menu, Modal, Space } from "antd";
import moment from "moment";
import { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import BillingExtendModal from "../../../components/BillingExtendModal";
import { OfferModal } from "../../../components/OfferModal";
import PlaceBidModal from "../../QueryPage/components/organisms/PlaceBidModal";
import budgetOptions from "../../../components/PlaceBidModal/BidEnum";
import {
  editJobOffer,
  makeOffer,
  retractBid,
  updateBid,
  updateProposal,
  updateInterview,
  clearRatingCheck
} from "../../../redux/actions";
import InterviewDrawer from "../../ProfileDetail/InterviewDrawer/interviewDrawer";
import RejectionModal from "./RejectionModal/RejectionModal";
import history from "../../../routes/history";
export default function CustomDropdown({
  status,
  type,
  bidData,
  mobile,
  setStatusName,
  applyFilter,
  SkillListings,
}) {
  const dispatch = useDispatch();

  const RetractLoading = useSelector(
    (state) => state.retractBidReducers.loading
  );

  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [bid, setBid] = useState(false);

  const [offerData, setOfferData] = useState(false);
  const [interviewDrawer, setinterviewDrawer] = useState(false);
  const [bidId, setbidId] = useState(false);
  const [InterviewId, setInterviewId] = useState(false);
  const [SkillListingId, setSkillListingId] = useState(false);
  const [scheduledTimings, setScheduledTimings] = useState(false);

  const [rejectionModalText, setRejectionModalText] = useState();
  const [rejectionModalTitle, setRejectionModalTitle] = useState();

  const [rejectModalVisible, setRejectModalVisible] = useState(false);
  const [openOfferModal, setOpenOfferModal] = useState(false);
  const [offerLoading, setOfferLoading] = useState(false);
  const [bidType, setBidType] = useState("");
  const [extendBilling, setExtendBilling] = useState(false);
  const [reScheduleInterviewHook, setReScheduleInterviewHook] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [hire, setHire] = useState(false);
  const inputA = useRef(null);
  const inputN = useRef(null);
  const inputAs = useRef(null);
  const [rejectReason, setRejectReason] = useState(false);
  const profile = JSON.parse(localStorage.getItem("userProfile"));

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleReasonSubmit = () => {
    // if (isSelected && decline === "decline-interview") {
    dispatch(
      updateInterview({
        // id: "jasdkflj64657987987",
        InterviewId: InterviewId,
        reschedule: true,
        // body: {
        // ReScheduledTimings: [
        //   {
        //     StartTime: "2022-06-23T17:45:00.000+00:00",
        //     EndTime: "2022-06-23T18:45:00.000+00:00",
        //   },
        //   {
        //     StartTime: "2022-06-22T17:45:00.000+00:00",
        //     EndTime: "2022-06-22T18:45:00.000+00:00",
        //   },
        // ],
        InterviewStatus: "Rejected",
        type: "emp",
        ReasonId: rejectReason,
        // },
      })
    );

    handleOk();
  };

  function rejectModalClose(params) {
    setRejectModalVisible(false);
    setIsModalVisible(false);
  }

  const handleNewBidMenu = (menuItem) => {
    if (menuItem.key == "edit") {
      setBid(bidData);
      setVisible2(true);
      setSkillListingId(bidData?.SkillListings?.SkillListingId);
    } else if (menuItem.key == "retract_bid") {
      setBid(bidData);
      setVisible(true);
    } else if (menuItem.key == "Profile_Submitted") {
      if (bidData?.SkillListings) {
        dispatch(
          updateBid({
            BidStatusName: "Profile Submitted",
            id: bidData?.BidId,
            SkillListingId: SkillListings?.SkillListingId,
          })
        );
      } else {
        dispatch(
          updateProposal({
            status: "Profile Submitted",
            id: bidData?.ProposalId,
          })
        );
      }
    } else if (menuItem.key == "schedule_interview") {
      if(bidData?.ProposalId){
        setbidId(bidData?.ProposalId);
        setBidType("proposal")
      }else{
        setbidId(bidData?.BidId);
        setBidType("bid");
      }
      setinterviewDrawer(true);
      
     
    } else if (menuItem.key == "make_offer") {
      MakeOffer();
    } else if (menuItem.key == "hired") {
      if(bidData?.offers){
        dispatch(
          editJobOffer(
            { Status: "Hired", BidType: bidData?.SkillListings ? "Bid" : "Proposals" },
            { id: bidData?.SkillListings ? bidData?.BidId : bidData?.ProposalId}
          )
        );
      } else {
        // dispatch(
        //   editJobOffer(
        //     { Status: "Hired", BidType: bidData?.SkillListings ? "Bid" : "Proposals" },
        //     { id: bidData?.SkillListings ? bidData?.BidId : bidData?.received?.ProposalId }
        //   )
        // );
        MakeOffer();
        setHire(true);
      }
    }
  };
  const handleReceivedNewBidMenu = (menuItem) => {
    if (menuItem.key == "accept") {
      dispatch(
        updateProposal({
          status: "Accepted",
          id: bidData?.ProposalId ||  bidData?.received?.ProposalId,
        })
      );
    } else if (menuItem.key == "decline") {
      setRejectModalVisible(true);
    } else if (menuItem.key == "Profile_Submitted") {
      if (bidData?.SkillListings) {
        dispatch(
          updateBid({
            BidStatusName: "Profile Submitted",
            id: bidData?.BidId,
            SkillListingId: SkillListings?.SkillListingId,
          })
        );
      } else {
        dispatch(
          updateProposal({
            status: "Profile Submitted",
            id: bidData?.ProposalId,
          })
        );
      }
    } else if (menuItem.key == "schedule_interview") {
      if(bidData?.ProposalId){
        setbidId(bidData?.ProposalId);
        setBidType("proposal")
      }else{
        setbidId(bidData?.BidId);
        setBidType("bid");
      }
      setinterviewDrawer(true);
      
    } else if (menuItem.key == "make_offer") {
      MakeOffer();
    } else if (menuItem.key == "hired") {
      if(bidData?.offers){
        dispatch(
          editJobOffer(
            { Status: "Hired", BidType: bidData?.SkillListings ? "Bid" : "Proposals" },
            { id: bidData?.SkillListings ? bidData?.BidId : bidData?.ProposalId || bidData?.received?.ProposalId}
          )
        );
      } else {
        setHire(true);
        MakeOffer();
      }
    }
  };

  const HandleAcceptedBidMenu = (menuItem) => {
    if (menuItem.key == "Profile_Submitted") {
      if (bidData?.SkillListings) {
        dispatch(
          updateBid({
            BidStatusName: "Profile Submitted",
            id: bidData?.BidId,
            SkillListingId: SkillListings?.SkillListingId,
          })
        );
      } else {
        dispatch(
          updateProposal({
            status: "Profile Submitted",
            id: bidData?.ProposalId || bidData?.received?.ProposalId,
          })
        );
      }
    } else if (menuItem.key == "schedule_interview") {
      if(bidData?.ProposalId){
        setbidId(bidData?.ProposalId);
        setBidType("proposal")
      }else{
        setbidId(bidData?.BidId);
        setBidType("bid");
      }
      setinterviewDrawer(true);
    } else if (menuItem.key == "make_offer") {
      MakeOffer();
    } else if (menuItem.key == "hired") {
      if(bidData?.offers){
        MakeOffer();
      } else {dispatch(
        editJobOffer(
          { Status: "Hired", BidType: bidData?.SkillListings ? "Bid" : "Proposals" },
          { id: bidData?.SkillListings ? bidData?.BidId : bidData?.ProposalId || bidData?.received?.ProposalId}
        )
      );}
    }
  };

  const handleOkNewBid = () => {
    dispatch(
      retractBid({
        BidStatusName: "Retracted",
        id: bidData?.BidId,
        Message: "Bid was retracted",
        SkillListingId: SkillListings?.SkillListingId,
      })
    );
  };

  const handleCancelNewBid = () => {
    setVisible(false);
  };

  const MakeOffer = () => {
    setbidId(bidData?.BidId);
    setOpenOfferModal(true);
  };

  const EditOffer = () => {
    setOfferData(bidData?.offers);
    setbidId(bidData?.BidId);
    setOpenOfferModal(true);
  };

  const handleProfileSubmittedBidMenu = (menuItem) => {
    if (menuItem.key == "schedule_interview") {
      if(bidData?.ProposalId){
        setbidId(bidData?.ProposalId);
        setBidType("proposal")
      }else{
        setbidId(bidData?.BidId);
        setBidType("bid");
      }
      setinterviewDrawer(true);
      
    }
    if (menuItem.key == "make_offer") {
      MakeOffer();
    }
    if (menuItem.key == "hired") {
      if(bidData?.offers){
        dispatch(
          editJobOffer(
            { Status: "Hired", BidType: bidData?.SkillListings ? "Bid" : "Proposals" },
            { id: bidData?.SkillListings ? bidData?.BidId : bidData?.ProposalId}
          )
        );
      } else {
        MakeOffer();
        setHire(true);
      }
    }
    if (menuItem.key == "reject") {
      setbidId(bidData?.BidId);
      setSkillListingId(bidData?.SkillListings?.SkillListingId);
      setRejectionModalText(
        "Let us know why you’re declining this bid:"
      );
      setRejectionModalTitle("Reject this Candidate?");
      setRejectModalVisible(true);
    }
  };

  const handleInterviewStatusMenu = (menuItem) => {
    if (menuItem.key == "edit") {
      setbidId(bidData?.BidId);
      setInterviewId(bidData?.Interview[0].InterviewId);
      setScheduledTimings(bidData?.Interview[0].ReScheduledTimings.length == 0 ? bidData?.Interview[0].Interviews_ScheduledTimings : bidData?.Interview[0].ReScheduledTimings[bidData?.Interview[0].ReScheduledTimings.length-1] );
      setinterviewDrawer(true);
    } else if (menuItem.key == "cancel_interview") {
      setbidId(bidData?.BidId);
      //InterviewId
      setRejectModalVisible(true);
      setSkillListingId(bidData?.SkillListings ? bidData?.SkillListings?.SkillListingId : null);
      setInterviewId(bidData?.Interview[0].InterviewId);
      setRejectionModalText("Please select a reason for cancelling this interview");
      setRejectionModalTitle("Cancel this Interview?");
    } else if(menuItem.key == "accept"){
      if (bidData?.ConversationId) {
        history.push({
          pathname: '/conversations',
          state: {
            openConvo: true,
            conversationId: bidData?.ConversationId
          }
        })
      }
    } else if(menuItem.key == "decline"){
      setIsModalVisible(true);
      setbidId(bidData?.BidId);
      setInterviewId(bidData?.Interview[0].InterviewId);
    } else if(menuItem.key == "rescheduel"){
      setReScheduleInterviewHook(true);
      setbidId(bidData?.BidId);
      setInterviewId(bidData?.Interview[0].InterviewId);
      setScheduledTimings(bidData?.Interview[0].ReScheduledTimings.length == 0 ? bidData?.Interview[0].Interviews_ScheduledTimings : bidData?.Interview[0].ReScheduledTimings[bidData?.Interview[0].ReScheduledTimings.length-1] );
      setinterviewDrawer(true);
      bidData?.received?.ProposalId ? setBidType("proposal") : setBidType("bid");
    } else if (menuItem.key == "make_offer") {
      MakeOffer();
    } else if (menuItem.key == "hired") {
      if(bidData?.offers){
        dispatch(
          editJobOffer(
            { Status: "Hired", BidType: bidData?.SkillListings ? "Bid" : "Proposals" },
            { id: bidData?.SkillListings ? bidData?.BidId : bidData?.ProposalId}
          )
        );
      } else {
        MakeOffer();
        setHire(true);
      }
    }
  };

  const handleEditOfferBidMenu = (menuItem) => {
    if (menuItem.key == "schedule_interview") {
      if(bidData?.ProposalId){
        setbidId(bidData?.ProposalId);
        setBidType("proposal")
      }else{
        setbidId(bidData?.BidId);
        setBidType("bid");
      }
      setinterviewDrawer(true);
      
    }else if (menuItem.key == "edit_offer") {
      EditOffer();
    } else if (menuItem.key == "hired") {
      dispatch(
        editJobOffer(
          { Status: "Hired", BidType: bidData?.SkillListings ? "Bid" : "Proposals" },
          { id: bidData?.SkillListings ? bidData?.BidId : bidData?.received?.ProposalId || bidData?.ProposalId }
        )
      );
    }
  };

  const handleOfferAcceptedStatusMenu = (menuItem) => {
    if (menuItem.key == "schedule_interview") {
      if(bidData?.ProposalId){
        setbidId(bidData?.ProposalId);
        setBidType("proposal")
      }else{
        setbidId(bidData?.BidId);
        setBidType("bid");
      }
      setinterviewDrawer(true);
      
    }else if (menuItem.key == "hired") {
      dispatch(
        editJobOffer(
          { Status: "Hired", BidType: bidData?.SkillListings ? "Bid" : "Proposals" },
          { id: bidData?.SkillListings ? bidData?.BidId : bidData?.ProposalId}
        )
      );
    }
  };

  const handleInterviewAcceptedStatusMenu = (menuItem) => {
    if (menuItem.key == "schedule_interview") {
      if(bidData?.ProposalId){
        setbidId(bidData?.ProposalId);
        setBidType("proposal")
      }else{
        setbidId(bidData?.BidId);
        setBidType("bid");
      }
      setinterviewDrawer(true);
      
    }else if (menuItem.key == "make_offer") {
      MakeOffer();
    } else if (menuItem.key == "reject") {
      setbidId(bidData?.BidId);
      //InterviewId
      setInterviewId(bidData?.Interview[0].InterviewId);
      setRejectionModalText(
        "Please select a reason for cancelling this interview"
      );
      setRejectionModalTitle("Cancel this Interview?");
      setRejectModalVisible(true);
    }
  };

  const handleOnBillingStatusMenu = (menuItem) => {
    if (menuItem.key == "schedule_interview") {
      if(bidData?.ProposalId){
        setbidId(bidData?.ProposalId);
        setBidType("proposal")
      }else{
        setbidId(bidData?.BidId);
        setBidType("bid");
      }
      setinterviewDrawer(true);
      
    }else if (menuItem.key == "Billing_Extended") {
      setExtendBilling(true);
      setbidId(bidData?.BidId);
      SkillListings && setSkillListingId(bidData?.SkillListings?.SkillListingId);
    }
    if (menuItem.key == "Off Billing") {
      dispatch(
        editJobOffer({ Status: "Off Billing" , BidType: bidData?.SkillListings ? "Bid" : "Proposals"}, 
        { id: bidData?.SkillListings ? bidData?.BidId : bidData?.ProposalId ||  bidData?.received?.ProposalId})
      );
      dispatch(clearRatingCheck())
      history.push({
        pathname: "/ratings",
        state: {
          bidId: bidData.BidId,
          proposalId: bidData?.ProposalId || bidData?.received?.ProposalId,
          image: bidData?.user?.Profiles?.PictureUrl,
          candidate_name: bidData?.user?.Profiles.FirstName,
          skill_listing_title: bidData?.SkillListings?.Title,
          job_title: bidData?.gigs?.Title,
          date_from: bidData?.offers?.FromDate,
          date_to: bidData?.offers?.ToDate,
          rating: false,
          previousScreen: "Manage Candidates",
          isEdit: false,
          conversationId: bidData.ConversationId,
          SourceTypeId: bidData?.bidType == "Placed" ? 1 : 2,
          Reviewee: bidData?.SkillListings
            ? bidData?.SkillListings?.CreatedBy
            : bidData?.user ? bidData?.user.AccountId 
            : bidData?.received?.CreatedBy,
        },
      });
      // applyFilter(menuItem.key, "All_Bids");
    }
    if (menuItem.key == "Terminated") {
      dispatch(
        editJobOffer({ Status: "Terminated" , BidType: bidData?.SkillListings ? "Bid" : "Proposals"}, 
        { id: bidData?.SkillListings ? bidData?.BidId : bidData?.ProposalId})
      );

      // applyFilter(menuItem.key, "All_Bids");
    }
    if (menuItem.key == "Cancelled") {
      dispatch(
        editJobOffer({ Status: "Cancelled" , BidType: bidData?.SkillListings ? "Bid" : "Proposals"}, 
        { id: bidData?.SkillListings ? bidData?.BidId : bidData?.ProposalId})      );
    }
  };

  const NewBidStatusMenu = (
    <Menu 
      style={{border:'solid 1px #dedede',zIndex: "999"}}
      onClick={(menuItem) => handleNewBidMenu(menuItem)}>
      <Menu.Item key="edit">Edit</Menu.Item>
      <Menu.Item key="retract_bid">Retract bid</Menu.Item>
      <Menu.Item key="Profile_Submitted">Profile submitted</Menu.Item>
      <Menu.Item key="schedule_interview">Schedule interview</Menu.Item>
      <Menu.Item key="make_offer">Make an offer</Menu.Item>
      <Menu.Item key="hired">Hired</Menu.Item>
      <Menu.Divider />
      <Menu.Item disabled key="schedule_interview" style={{ color: '#D4D4D4 !important'   }}>
        Schedule Call</Menu.Item>
    </Menu>
  );

  const NewBidStatusBidMenu = (
    <Menu onClick={(menuItem) => handleReceivedNewBidMenu(menuItem)} style={{border:'solid 1px #dedede'}}>
      <Menu.Item key="accept">Interested</Menu.Item>
      <Menu.Item key="decline">Not Interested</Menu.Item>
      <Menu.Item key="Profile_Submitted">Profile submitted</Menu.Item>
      <Menu.Item key="schedule_interview">Schedule interview</Menu.Item>
      <Menu.Item key="make_offer">Make an offer</Menu.Item>
      <Menu.Item key="hired">Hired</Menu.Item>
      <Menu.Divider />
      <Menu.Item disabled key="schedule_interview" className="customize-disable-menu-item">
        Schedule Call</Menu.Item>
    </Menu>
  );

  const AcceptedBidStatusMenu = (
    <Menu onClick={(menuItem) => HandleAcceptedBidMenu(menuItem)} style={{border:'solid 1px #dedede'}}>
      <Menu.Item key="Profile_Submitted">Profile submitted</Menu.Item>
      <Menu.Item key="schedule_interview">Schedule interview</Menu.Item>
      <Menu.Item key="make_offer">Make an offer</Menu.Item>
      <Menu.Item key="hired">Hired</Menu.Item>
      <Menu.Divider />
      <Menu.Item disabled key="schedule_interview" style={{ color: '#D4D4D4 !important'   }}>
        Schedule Call</Menu.Item>
    </Menu>
  );

  const ProfileSubmittedStatusMenu = (
    <Menu onClick={(menuItem) => handleProfileSubmittedBidMenu(menuItem)} style={{border:'solid 1px #dedede'}}>
      <Menu.Item key="schedule_interview">Schedule interview</Menu.Item>
      <Menu.Item key="make_offer">Make an offer</Menu.Item>
      <Menu.Item key="hired">Hired</Menu.Item>
      <Menu.Item key="reject">Decline candidate</Menu.Item>
      <Menu.Divider />
      <Menu.Item  key="schedule_interview">
        Schedule Call</Menu.Item>
    </Menu>
  );

  const InterviewStatusMenu =  (
    <Menu onClick={(menuItem) => handleInterviewStatusMenu(menuItem)}>
      <Menu.Item key="edit">Edit</Menu.Item>
      <Menu.Item key="cancel_interview">Cancel interview</Menu.Item>
      <Menu.Item key="make_offer">Make an offer</Menu.Item>
      <Menu.Item key="hired">Hired</Menu.Item>
    </Menu>
  );
    
  const InterviewStatusBidMenu = ( 
  <Menu onClick={(menuItem) => handleInterviewStatusMenu(menuItem)}>
      <Menu.Item key="accept">Accept</Menu.Item>
      <Menu.Item key="decline">Decline</Menu.Item>
      <Menu.Item key="rescheduel">Request to Rescheduel</Menu.Item>
      <Menu.Item key="make_offer">Make an offer</Menu.Item>
      <Menu.Item key="hired">Hired</Menu.Item>
    </Menu>
  );

  const interviewAcceptedStatusMenu = (
    <Menu
      onClick={(menuItem) => {
        handleInterviewAcceptedStatusMenu(menuItem);
      }}
      style={{border:'solid 1px #dedede'}}
    >
      <Menu.Item key="make_offer">Make an offer</Menu.Item>
      <Menu.Item key="hired">Hired</Menu.Item>
      <Menu.Item key="reject">Decline candidate</Menu.Item>
      <Menu.Divider />
      <Menu.Item key="schedule_interview">
        Schedule Call</Menu.Item>
    </Menu>
  );

  const OfferStatusMenu = (
    <Menu onClick={(menuItem) => handleEditOfferBidMenu(menuItem)} style={{border:'solid 1px #dedede'}}>
      <Menu.Item key="edit_offer">Edit offer</Menu.Item>
      <Menu.Item key="hired">Hired</Menu.Item>
      <Menu.Divider />
      <Menu.Item key="schedule_interview">Schedule Call</Menu.Item>
    </Menu>
  );

  const offerAcceptedStatusMenu = (
    <Menu
      onClick={(menuItem) => {
        handleOfferAcceptedStatusMenu(menuItem)
      }}
      style={{border:'solid 1px #dedede'}}
    >
      <Menu.Item key="hired">Hired</Menu.Item>
      <Menu.Divider />
      <Menu.Item key="schedule_interview">Schedule Call</Menu.Item>
    </Menu>
  );

  const onBillingExtendedStatusMenu = (
    <Menu
      onClick={(menuItem) => {
        handleOnBillingStatusMenu(menuItem);
      }}
      style={{border:'solid 1px #dedede'}}
    >
      <Menu.Item key="Billing_Extended">Billing extended</Menu.Item>
      <Menu.Item key="Off Billing">Off billing</Menu.Item>
      <Menu.Item key="Terminated">Terminated</Menu.Item>
      <Menu.Item key="Cancelled">Canceled</Menu.Item>
      {/* <Menu.Item key="schedule_interview">Schedule Call</Menu.Item> */}
    </Menu>
  );

  const onBillingStatusMenu = (
    <Menu
      onClick={(menuItem) => {
        handleOnBillingStatusMenu(menuItem);
      }}
      style={{border:'solid 1px #dedede'}}
    >
      <Menu.Item key="Billing_Extended">Billing extended</Menu.Item>
      <Menu.Item key="Off Billing">Off billing</Menu.Item>
      <Menu.Item key="Terminated">Terminated</Menu.Item>
      <Menu.Item key="Cancelled">Canceled</Menu.Item>
      {/* <Menu.Divider />
      <Menu.Item key="schedule_interview">Schedule Call</Menu.Item> */}
      </Menu>
  );

  const statusCheck = () => {
    //Checks For Bidds
    if (status == "New") {
      if (SkillListings) {
        return NewBidStatusMenu;
      } else {
        return NewBidStatusBidMenu;
      }
    } else if (status == "Accepted") {
      return AcceptedBidStatusMenu;
    } else if (status == "Profile Submitted") {
      return ProfileSubmittedStatusMenu;
    } else if (status == "Interview") {
      let profileId = bidData?.received ? parseInt(profile?.AccountId) : parseInt(bidData?.ProfileId);
        if(bidData?.Interview?.length > 0 && (parseInt(bidData?.Interview[0]?.ModifiedBy) == profileId)){
          return InterviewStatusMenu;
        } else {
          return InterviewStatusBidMenu;
        }
    } else if (status == "Interview Accepted") {
      return interviewAcceptedStatusMenu;
    } else if (status == "Offer") {
      return OfferStatusMenu;
    } else if (status == "Offer Accepted") {
      return offerAcceptedStatusMenu;
    } else if (status == "On Billing") {
      return onBillingStatusMenu;
    } else if (status == "Billing Extend") {
      return onBillingExtendedStatusMenu;
    } else {
      return 1;
    }
  };
  
  var candidateList = [
    {
      id: bidData?.SkillListings?.SkillListingId,
      img: bidData?.user?.Profiles.PictureUrl,
      name: bidData?.user?.Profiles?.FirstName ? bidData?.user?.Profiles?.FirstName + " " + bidData?.user?.Profiles?.LastName : "",
      experience: bidData?.user?.Profiles?.ExperienceLevels?.ExperienceLevelName
        ? bidData?.user?.Profiles?.ExperienceLevels?.ExperienceLevelName
        : "N/A",
      title: bidData?.SkillListings?.Title,
      desired_rate: bidData?.SkillListings?.MinimumBid?.$numberDecimal ? Math.floor(bidData?.SkillListings?.MinimumBid?.$numberDecimal) : bidData?.SkillListings?.MinimumBid,
      bidType: bidData?.BudgetTypeId ? budgetOptions?.find((o) => {
        return o.BudgetTypeId === bidData?.BudgetTypeId;
      })?.BudgetType : "",
      lastActive: bidData?.user?.LastSuccessfulLoginDate ? moment(bidData?.user?.LastSuccessfulLoginDate).fromNow() : "N/A",
    },
  ];
  return (
    <div 
    onClick={(e) => {e.stopPropagation()}} >

      <Modal
        title="Retract Bid?"
        visible={visible}
        onCancel={() => setVisible(false)}
        centered
        // okText={'Yes'}
        // cancelText={'No'}
        footer={[
          <>
            <Button onClick={handleCancelNewBid} className="modal-no-btn-retract">
            No, go back
            </Button>
            <Button onClick={handleOkNewBid} className="modal-ok-btn-retract">
              {RetractLoading ? <LoadingOutlined /> : "Yes , delete it"}
            </Button>
          </>,
        ]}
      >
        <p>Do you want to retract your placed bid?</p>
      </Modal>

      <Modal
        title="Decline Interview?"
        onCancel={rejectModalClose}
        visible={isModalVisible}
        footer={null}
      >
        <div>Please select a reason for not interested</div>
        <div
          ref={inputA}
          className="reject-modal-div"
          data-id="Accepted another candidate"
          onClick={(e) => {
            inputA.current.value = "Accepted another candidate";
            inputA.current.style.backgroundColor = "#e4ffec";
            inputN.current.style.backgroundColor = "white";
            inputAs.current.style.backgroundColor = "white";
            setRejectReason(1);
          }}
        >
          Accepted Another Candidate
        </div>
        <div
          ref={inputN}
          className="reject-modal-div"
          data-id="Not interested"
          onClick={(e) => {
            inputA.current.value = "Not Interested in the candidate";
            inputA.current.style.backgroundColor = "white";
            inputN.current.style.backgroundColor = "#e4ffec";
            inputAs.current.style.backgroundColor = "white";
            setRejectReason(3);
          }}
        >
          Not Interested
        </div>
        <div
          ref={inputAs}
          className="reject-modal-div"
          data-id="user deactivated account"
          onClick={(e) => {
            inputA.current.value = "Asking Payrate is too high";
            inputA.current.style.backgroundColor = "white";
            inputN.current.style.backgroundColor = "white";
            inputAs.current.style.backgroundColor = "#e4ffec";
            setRejectReason(2);
          }}
        >
          User Deactivated Account
        </div>

        <button className="rejectModalBtn" onClick={() => handleReasonSubmit()}>
          Decline Interview
        </button>
      </Modal>
 
      <PlaceBidModal
        open={visible2}
        talent={{
          name: bidData?.Profiles?.FirstName ? `${bidData.Profiles.FirstName} ${bidData.Profiles.LastName || ''}`.trim() : '',
          title: bidData?.SkillListings?.Title || '',
          avatar: bidData?.Profiles?.PictureUrl ? `${process.env.REACT_APP_S3_URL}/${bidData.Profiles.PictureUrl}` : null,
          initials: '',
        }}
        talentType="internal"
        skillListingId={SkillListingId}
        editBidData={{
          bidId: bidData?.BidId,
          rate: bidData?.Rate?.$numberDecimal ?? bidData?.Rate,
          comments: bidData?.Comments,
          budgetType: budgetOptions?.find(o => o.BudgetTypeId === bidData?.BudgetTypeId)?.BudgetType,
          idealTerm: bidData?.IdealTerm,
          startDate: bidData?.IdealStartDate,
          taxTerm: 'w2',
          job: bidData?.gigs,
        }}
        onClose={() => setVisible2(false)}
      />

      <BillingExtendModal
        visible={extendBilling}
        setVisible={setExtendBilling}
        onClose={() => setExtendBilling(false)}
        desired_rate={bidData?.Rate}
        bidId={bidId}
        skillListingId={SkillListingId}
        receivedId={bidData?.ProposalId}
        source={bidData?.bidType == "Received" ? 2 : 1}
      />

      <InterviewDrawer
        reSchedule={reScheduleInterviewHook}
        bid={bidData?.BidId}
        bidType={bidData?.bidType}
        interviewId={InterviewId}
        timings={scheduledTimings}
        open={interviewDrawer}
        close={setinterviewDrawer}
        receivedId={bidData?.ProposalId || bidData?.received?.ProposalId}
      />
      <RejectionModal
        bid={bidData?.BidId}
        interviewId={InterviewId}
        SkillListingId={SkillListingId}
        id={bidData? bidData?.ProposalId :bidData?.BidId}
        text={rejectionModalText}
        title={rejectionModalTitle}
        open={rejectModalVisible}
        close={setRejectModalVisible}
        bidData={bidData}
      />
      { openOfferModal &&
        (<OfferModal
          visible={openOfferModal}
          setOpenOfferModal={() => {
            setOpenOfferModal(false);
            setHire(false);
          }}
          bidID={bidData?.ProposalId || bidData?.BidId}
          editOffer={offerData}
          SkillListingId={SkillListings?.SkillListingId}
          source={bidData?.bidType}
          // stage={status}
          hire={hire}
          setOfferLoading={setOfferLoading}
        />
      )}

      {mobile ? (
        <Dropdown
          overlay={statusCheck}
          className="drop1"
          overlayClassName="dropdown-div"
          trigger={["click"]}
          disabled={statusCheck() == 1}
        >
          <Space
            style={{
              display: "flex",
              justifyContent: "center",
              columnGap: "0.5rem",
              alignItems: "center",
            }}
          >
            <div className="Manage-candidate-status-text">{status}</div>&nbsp;
            {status == "Off Billing" || status == "Terminated" || status == "Canceled" || status == "Offer Declined"
              || status == "Interview Cancelled" || status == "Declined" ? null : 
              <DownOutlined style={{ color: "#4e4e4e", fontSize: "2.5vw" }} />}           
          </Space>
        </Dropdown>
      ) : ( 
        <Dropdown
          overlay={statusCheck}
          className="firstDropDownBox"
          trigger={["click"]}
          disabled={statusCheck() == 1}
        >
          <Button>
            <Space>
              <div className="firstDropDownText">{status}</div>
              {status == "Off Billing" || status == "Terminated" || status == "Canceled" || status == "Offer Declined"
              || status == "Interview Cancelled" || status == "Declined" ? null : 
              <DownOutlined style={{color: '#7e7e7e'}}  />}
            </Space>
          </Button>
        </Dropdown>
      )}
    </div>
  );
}
